import React from 'react';
import IconButton from '@mui/material/IconButton';
import DocViewer, { DocViewerRenderers, MSDocRenderer } from '@cyntler/react-doc-viewer';
import { Backdrop, CircularProgress } from '@mui/material';
import DownloadIcon from '../Icons/DownloadIcon';
import CloseButtonIcon from '../Icons/CloseButtonIcon';
import { useWindowSize } from '../../../utils/hooks';
import { responsiveSizeTimesheet } from '../../../utils/constants';
import colors from '../../../scss/colors';
import classes from './CustomDocViewer.module.scss';

const CustomDocViewer = ({ settings, handleDownload, close, isLoading }) => {
  const { width } = useWindowSize();

  return (
    <Backdrop open sx={{ zIndex: 1310 }}>
      {isLoading ? (
        <CircularProgress sx={{ color: colors.WHITE }} size={60} />
      ) : (
        <>
          <div className={classes.docViewerActions}>
            {width <= responsiveSizeTimesheet && <p className={classes.filename}>{settings.filename}</p>}
            <IconButton onClick={handleDownload}>
              <DownloadIcon
                width={width > responsiveSizeTimesheet ? '25px' : '20px'}
                color={width > responsiveSizeTimesheet ? '' : colors.BLACK_TXT}
              />
            </IconButton>
            <IconButton onClick={close}>
              <CloseButtonIcon
                width={width > responsiveSizeTimesheet ? '25px' : '18px'}
                color={width > responsiveSizeTimesheet ? '' : colors.BLACK_TXT}
              />
            </IconButton>
          </div>
          <div className={classes.docViewerContainer}>
            <DocViewer
              config={{ header: { disableHeader: true } }}
              documents={[
                {
                  uri: settings?.data,
                  fileName: settings?.filename
                }
              ]}
              pluginRenderers={[...DocViewerRenderers, MSDocRenderer]}
            />
          </div>
        </>
      )}
    </Backdrop>
  );
};

export default CustomDocViewer;
